import { Artwork } from "@/lib/types";
import { t } from "i18next";
import { ComputeFieldComponent } from "../../computeFields";

export function formatOeuvresDescriptionPoidsDisplay(
  weight: string | null | undefined,
  language: string,
): string | null {
  const trimmed = weight?.trim() ?? "";
  if (!trimmed) return null;

  const normalized = trimmed.replace(",", ".");
  const numeric = Number.parseFloat(normalized);
  if (!Number.isNaN(numeric)) {
    return `${numeric.toLocaleString(language, { maximumFractionDigits: 10 })} kg`;
  }

  return trimmed.toLowerCase().includes("kg") ? trimmed : `${trimmed} kg`;
}

export const ArtworkWeightCF: ComputeFieldComponent<
  Pick<
    Artwork,
    "oeuvresDescriptionPoidsOeuvre" | "oeuvresDescriptionPoidsOeuvrePublished"
  >
> = ({ input, language }) => {
  if (input.oeuvresDescriptionPoidsOeuvrePublished !== true) {
    return <></>;
  }

  const formatted = formatOeuvresDescriptionPoidsDisplay(
    input.oeuvresDescriptionPoidsOeuvre,
    language,
  );

  if (formatted) {
    return <>{formatted}</>;
  }

  return <>{t("computeField.weightUnknown", { lng: language })}</>;
};
